import axios from "axios";
import { config } from "../config";
import { userService } from "./UserService";

export class DeviceService {
    getRequestHeaders() {
        const authToken = userService.getAuthToken();
        if (!authToken) {
            throw new Error("Authentication token is missing");
        }

        return {
            Authorization: `${authToken}`,
            "Content-Type": "application/json",
        };
    }

    async getFirmwareVersions() {
        const apiUrl = config.getApiUrl("deviceUtility");
        if (!apiUrl) {
            throw new Error("API URL is not defined");
        }

        try {
            const result = await axios.get(`${apiUrl}/firmware/`, {
                headers: this.getRequestHeaders(),
            });

            if (!Array.isArray(result.data)) {
                console.error("Unexpected response structure while fetching firmware versions");
                return [];
            }

            return result.data;
        } catch (error) {
            console.error(`Error while fetching available firmware versions: ${error}`);
            throw error;
        }
    }

    async provision(deviceIds, firmware) {
        const apiUrl = config.getApiUrl("deviceUtility");
        if (!apiUrl) {
            throw new Error("API URL is not defined");
        }

        try {
            const logs = await axios.get(`${apiUrl}/provision/${deviceIds}/${firmware}`, {
                headers: this.getRequestHeaders(),
            });

            if (typeof logs.data !== "object" || logs.data === null) {
                console.error("Unexpected response structure while provisioning device");
                return {};
            }

            return logs.data;
        } catch (error) {
            console.error(`Error while requesting provision: ${error}`);
            throw error;
        }
    }
}

export const deviceService = new DeviceService();
